<template>
  <header
    class="navbar navbar-header navbar-header-fixed"
    v-if="$store.state.user.userId == ''"
  >
    <a href="" id="mainMenuOpen" class="burger-menu d-none"
      ><svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-menu"
      >
        <line x1="3" y1="12" x2="21" y2="12"></line>
        <line x1="3" y1="6" x2="21" y2="6"></line>
        <line x1="3" y1="18" x2="21" y2="18"></line></svg
    ></a>
    <a href="" id="filemgrMenu" class="burger-menu d-lg-none"
      ><svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-arrow-left"
      >
        <line x1="19" y1="12" x2="5" y2="12"></line>
        <polyline points="12 19 5 12 12 5"></polyline></svg
    ></a>
    <div class="navbar-brand">
      <router-link to="/" class="df-logo"
        ><feather
          type="home"
          class="mg-r-5 ht-30-f wd-20-f"
          style="margin-top: -8px"
        ></feather
        >Оюуны өмчийн газар<span></span
      ></router-link>
    </div>
    <!-- navbar-brand -->
    <div id="navbarMenu" class="navbar-menu-wrapper" style="">
      <!-- <div class="navbar-menu-header">
          <router-link to="/" class="df-logo">Оюуны өмчийн<span>газар</span></router-link>
          <a id="mainMenuClose" href=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></a>
        </div> -->
      <ul class="nav navbar-menu" style="max-width: 880px; ">
        <!-- <li class="nav-item"><router-link to="/" class="nav-link"><feather type="menu" class="mg-r-5 ht-20-f wd-20-f" style="margin-top: -2px"></feather> Эхлэл</router-link></li> -->
        <li
          v-for="(cat, i) in news_category"
          :key="`ch${i}`"
          class="nav-item"
          :class="{
            active: $route.name == 'ipomLandings' && $route.params.lid == cat.id
          }"
        >
          <router-link :to="`/ipoms/${cat.id}`" class="nav-link"
            ><feather
              type="database"
              class="mg-r-5 ht-20-f wd-20-f"
              style="margin-top: -2px"
            ></feather>
            {{ cat.title }}</router-link
          >
        </li>
        <!-- <li class="nav-item" :class="{'active': $route.name=='ipomLandings' && $route.params.lid==95327}"><router-link to="/ipoms/95327" class="nav-link"><feather type="hard-drive" class="mg-r-5 ht-20-f wd-20-f" style="margin-top: -2px"></feather> Оюуны өмчийн итгэмжлэгдсэн төлөөлөгч</router-link></li> -->
      </ul>
    </div>
    <!-- navbar-menu-wrapper -->
    <div class="navbar-right" style="width: auto !important">
      <button @click="$router.push({ name: 'login' })" class="btn btn-buy">
        <feather type="log-in"></feather>
        <span>Системд нэвтрэх</span>
      </button>
    </div>
    <!-- navbar-right -->
  </header>
</template>

<script>
import { request } from "@/api/all";

export default {
  data() {
    return {
      news_category: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      request({
        api: { method: "GET", url: "Type/GetTreeData" },
        params: {
          parentId: 0,
          key: this.$store.state.app.activeGroup.publicPage.mainTypeKey
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.news_category = res.data.types;
        }
      });
    }
  }
};
</script>

<style></style>
